/**
 * Abbreviation of the agent shown in the properties list "Agent" column.
 *
 * Normally one initial ("J. Brewer"). When two different agents in the same
 * list share a last name, both get two initials ("Ja. Brewer", "Je. Brewer")
 * so the rows can be told apart.
 */

var AGENT_SLOTS = [1, 2, 3];

function clean(value) {
    return typeof value === 'string' ? value.trim() : '';
}

function key(value) {
    return clean(value).toLowerCase();
}

/**
 * The agent a row displays: the first of AGENT_1..3 that has a last name.
 * Agent 4 is the outside-agent marker and carries no name.
 */
function displayedAgent(row) {
    if (!row) return null;
    for (var i = 0; i < AGENT_SLOTS.length; i++) {
        var slot = AGENT_SLOTS[i];
        var lastName = clean(row['AGENT_' + slot + '_LAST_NAME']);
        if (lastName) {
            return { firstName: clean(row['AGENT_' + slot + '_FIRST_NAME']), lastName: lastName };
        }
    }
    if (clean(row.AGENT_4_LAST_NAME)) return { outsideAgent: true };
    return null;
}

/**
 * Last names belonging to more than one distinct first name across the list.
 * Case-insensitive; the same agent repeated on many rows is not a collision.
 *
 * @param {Array} rows the listings currently rendered
 * @returns {Set<string>} lower-cased last names that need a second initial
 */
function collidingLastNames(rows) {
    var firstNamesByLastName = {};
    var list = Array.isArray(rows) ? rows : [];

    list.forEach(function (row) {
        var agent = displayedAgent(row);
        if (!agent || agent.outsideAgent) return;
        var lastKey = key(agent.lastName);
        if (!firstNamesByLastName[lastKey]) firstNamesByLastName[lastKey] = {};
        firstNamesByLastName[lastKey][key(agent.firstName)] = true;
    });

    var colliding = new Set();
    Object.keys(firstNamesByLastName).forEach(function (lastKey) {
        if (Object.keys(firstNamesByLastName[lastKey]).length > 1) colliding.add(lastKey);
    });
    return colliding;
}

/**
 * `initials` is how many leading characters of the first name to show. Two
 * initials only distinguish names that actually differ there — "Jon"/"Joe"
 * both give "Jo." — so this is a best effort, not a guarantee.
 */
function abbreviateAgentName(firstName, lastName, initials) {
    var last = clean(lastName);
    if (!last) return '';
    var first = clean(firstName);
    if (!first) return last;
    return first.slice(0, Math.max(1, initials || 1)) + '. ' + last;
}

/**
 * Cell text for one row, given the colliding last names for the whole list.
 * "OA" for an outside agent and "" when no agent is set, as before.
 */
function agentColumnLabel(row, colliding) {
    var agent = displayedAgent(row);
    if (!agent) return '';
    if (agent.outsideAgent) return 'OA';
    var collides = !!(colliding && colliding.has(key(agent.lastName)));
    return abbreviateAgentName(agent.firstName, agent.lastName, collides ? 2 : 1);
}

module.exports = {
    collidingLastNames: collidingLastNames,
    abbreviateAgentName: abbreviateAgentName,
    agentColumnLabel: agentColumnLabel,
    displayedAgent: displayedAgent,
};
